import type { SVGProps } from "react";

const ArrowNarrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.92259 5.58925C9.24803 5.26382 9.24803 4.73618 8.92259 4.41074C8.59715 4.0853 8.06951 4.0853 7.74408 4.41074L2.74408 9.41074C2.41864 9.73618 2.41864 10.2638 2.74408 10.5893L7.74408 15.5893C8.06951 15.9147 8.59715 15.9147 8.92259 15.5893C9.24803 15.2638 9.24803 14.7362 8.92259 14.4107L5.34518 10.8333L16.6667 10.8333C17.1269 10.8333 17.5 10.4602 17.5 10C17.5 9.53976 17.1269 9.16667 16.6667 9.16667L5.34518 9.16666L8.92259 5.58925Z"
      fill="url(#paint0_linear_3482_60)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3482_60"
        x1="17.5"
        y1="10"
        x2="3.29709"
        y2="13.3647"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2C00B7" />
        <stop offset="0.665" stopColor="#B5307D" />
        <stop offset="1" stopColor="#FC9CAC" />
      </linearGradient>
    </defs>
  </svg>
);

export default ArrowNarrowLeft;
